var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationVat = function SvgGeneralCertificationVat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M5.984 10.498a4.5 4.5 0 1 0 .03-8.998 4.5 4.5 0 0 0-.03 8.998M4.395 5.503a.853.853 0 0 0 .852-.853.853.853 0 0 0-.836-.868.853.853 0 0 0-.852.853.853.853 0 0 0 .836.868m4.051 1.924a.853.853 0 0 1-.852.853.853.853 0 0 1-.836-.868.853.853 0 0 1 .852-.853c.466.004.84.393.836.868M8.16 3.82a.455.455 0 0 0-.652-.005l-3.696 3.7a.477.477 0 0 0-.006.665c.179.185.47.188.653.006l3.695-3.7a.477.477 0 0 0 .006-.666",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralCertificationVat;